/**
 * BIES Bundle Map - Shared mapping of bundle tiers
 * Used by both bies-volume-selector.js (product page) and bies-cart-drawer.js (cart)
 *
 * Each product has up to 4 tiers:
 *   Tier 1: Individual product (original variant)
 *   Tier 2: Bundle 2x (-10%, separate Shopify product)
 *   Tier 3: Bundle 3x (-15%, separate Shopify product)
 *   Tier 4: Bundle 4x (-20%, separate Shopify product)
 */

(function() {
  'use strict';

  // Full tier mapping: bundleCode → { 1: variantId, 2: variantId, 3: variantId, 4: variantId }
  var BUNDLE_VARIANTS = {
    'PANCAKES': {
      1: '51754148004187',
      2: '51905117552987',
      3: '51905126531419',
      4: '51905132462427'
    },
    'CAFE': {
      1: '51826441912667',
      2: '51905115423067',
      3: '51905123647835',
      4: '51905131413851'
    },
    'PROT-CH': {
      1: '51392127500635',
      2: '51911578911067',
      3: '51905124434267',
      4: '51905131577691'
    },
    'PROT-FR': {
      1: '51753624928603',
      2: '51905117127003',
      3: '51905125974363',
      4: '51905132101979'
    },
    'BEB-MIX': {
      1: '50914720481627',
      2: '51905117782363',
      3: '51905128333659',
      4: '51905135346011'
    },
    'BEB-TROP': {
      1: '50914696036699',
      2: '51905117978971',
      3: '51905128497499',
      4: '51905135509851'
    },
    'BEB-CITR': {
      1: '50914690138459',
      2: '51905118306651',
      3: '51905128628571',
      4: '51905135673691'
    },
    'BEB-LIM': {
      1: '50914686402907',
      2: '51905120174427',
      3: '51905128694107',
      4: '51905135804763'
    },
    'BEB-MAND': {
      1: '50914677457243',
      2: '51905120960859',
      3: '51905129808219',
      4: '51905136001371'
    },
    'BEB-DETOX': {
      1: '50914655404379',
      2: '51905121124699',
      3: '51905129939291',
      4: '51905136492891'
    },
    'STEVIA': {
      1: '49746062967131',
      2: '51911577108827',
      3: '51905126760795',
      4: '51905132659035'
    },
    'GRAN-CH': {
      1: '51155051053403',
      2: '51911578255707',
      3: '51905127285083',
      4: '51905133773147'
    },
    'GRAN-OR': {
      1: '51834478166363',
      2: '51911578190171',
      3: '51905128202587',
      4: '51905134166363'
    },
    'SHAKER': {
      1: '51386866663771',
      2: '51911578845531',
      3: '51905130398043',
      4: '51905136656731'
    },
    'MATCHA': {
      1: '51991563043163',
      2: '52061009084763',
      3: '52061009117531',
      4: '52061009150299'
    }
  };

  // Build reverse map: variantId (string) → { bundleCode, tier }
  var VARIANT_TO_BUNDLE = {};
  var codes = Object.keys(BUNDLE_VARIANTS);
  for (var c = 0; c < codes.length; c++) {
    var code = codes[c];
    var tiers = BUNDLE_VARIANTS[code];
    var tierKeys = Object.keys(tiers);
    for (var t = 0; t < tierKeys.length; t++) {
      var tier = parseInt(tierKeys[t], 10);
      var vid = String(tiers[tier]);
      VARIANT_TO_BUNDLE[vid] = { bundleCode: code, tier: tier };
    }
  }

  // Expose globals
  window.BIES_BUNDLE_VARIANTS = BUNDLE_VARIANTS;
  window.BIES_VARIANT_TO_BUNDLE = VARIANT_TO_BUNDLE;
  window.BIES_TIER_DISCOUNTS = { 1: 0, 2: 10, 3: 15, 4: 20 };
  window.BIES_MAX_TIER = 4;
  window.BIES_MIN_TIER = 1;

})();
